import type { FC } from 'react';
import { FormItemProps } from 'antd';
import { StyledFormItemHorizontal } from './FormItemHorizontal.styles';


export const FormItemHorizontal: FC<FormItemProps> = (props) => {
  return (
    <StyledFormItemHorizontal {...props} />
  );
};
